import axios from "axios";
import {
    Notification
} from "element-ui";

export function getStuScratchWorks(stuId, username, cb) {
    axios.get('https://scratch3.fun/newsys/get/sc/work/list/by/stu/id', {
        async: true,
        crossDomain: true,
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': "XMLHttpRequest"
        },
        params: {
            stuId: stuId,
            username: username
        }
    })
        .then(function (res) {
            console.log("查看老系统SC作品");
            console.log(res);
            if (res.status == 200 && res.data.status == 'success') {
                cb(res.data);
            }
            else if (res.status == 200 && res.data.status == 'fail') {
                Notification.warning({
                    title: "警告",
                    message: res.data.msg,
                });
            }
            else {
                Notification.error({
                    title: "错误",
                    message: "网络异常，请刷新重试！",
                });
            }
        })
        .catch(function (error) {
            console.log(error);
        });
}

export function getStuJrcodeWorks(stuId, username, cb) {
    axios.get('https://scratch3.fun/newsys/get/jr/work/list/by/stu/id', {
        async: true,
        crossDomain: true,
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': "XMLHttpRequest"
        },
        params: {
            stuId: stuId,
            username: username
        }
    })
        .then(function (res) {
            console.log("查看老系统JR作品");
            console.log(res);
            if (res.status == 200 && res.data.status == 'success') {
                cb(res.data);
            }
            else if (res.status == 200 && res.data.status == 'fail') {
                Notification.warning({
                    title: "警告",
                    message: res.data.msg,
                });
            }
            else {
                Notification.error({
                    title: "错误",
                    message: "网络异常，请刷新重试！",
                });
            }
        })
        .catch(function (error) {
            console.log(error);
        });
}
